import React from "react";
import "../styles/footer.css";

function Footer() {
  return (
    <footer className="footer">

      <div className="container text-center">

        <h3>LINK JAPAN (PVT) LTD</h3>

        <p><strong>Email:</strong> linkjapancom@gmail.com</p>
        <p><strong>Contact:</strong> +818030701961</p>

      </div>

      <div className="footer-bottom text-center">
        © {new Date().getFullYear()} LINK JAPAN (PVT) LTD. All Rights Reserved.
      </div>

    </footer>
  );
}

export default Footer;